<template>
  <div class="bodydiv">
    <div class="container w-container">
      <div class="imagediv">
        <img src="static/images/scwp_neg.png" alt="" class="image" />
      </div>
      <div class="text-block">LOGIN</div>
      <span style="color: red;" v-if="error">{{error}}</span>
      <div class="separator">
        <div class="logindiv">
          <div class="w-form">
            <form @submit.prevent class="form">
              <input
                v-model="username"
                type="text"
                class="text-field-2 w-input"
                maxlength="256"
                placeholder="Username"
              />
              <input
                v-model="password"
                type="password"
                class="text-field-3 w-input"
                maxlength="256"
                placeholder="Passwort"
              />
              <a @click="loginClicked()" href="#" class="updatebutton margin w-button">ANMELDEN</a>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HTTP from '@/service/httpservice'
import _ from 'lodash'

const loginService = new HTTP('/login')
export default {
  data () {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    loginClicked () {
      if (!this.username) {
        return
      }
      let usernameToSend = this.username + ''
      if (
        !this.username.endsWith('@scwp.com') &&
        !this.username.includes('@')
      ) {
        usernameToSend += '@scwp.com'
      }
      console.log('Username to send: ' + usernameToSend)
      loginService.post(
        {
          username: usernameToSend,
          password: this.password
        }
      ).then(res => {
        localStorage.setItem('username', usernameToSend)
        window.analytics.identify(usernameToSend, {
          name: usernameToSend,
          email: usernameToSend
        })
        this.error = ''
        console.log(res)
        const token = _.get(res, 'headers.authorization', '')
        if (!token) {
          this.error = 'Response has no token...'
          return
        }
        localStorage.setItem('token', token)
        this.$emit('loggedIn', token)
      }).catch(e => {
        const status = _.get(e, 'response.data.status', 500)
        if (status === 500) {
          this.error = 'Unknown error...'
        } else if (status === 404) {
          this.error = 'Username oder Passwort falsch!'
        } else {
          this.error = _.get(e, 'response.data.message', 'Unknown error...')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Login.vue